$(document).ready(function() {
    $('.js-btn-close-alert').on('click', function() {
        let $cookieName = $(this).closest('.site-banner').first().data('cookieName');
        
        $(this).closest('.site-banner').slideUp('fast', function() {
            $(this).remove();
        });
        
        createCookie($cookieName, true, 60);
    });
});